import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Slide from '@mui/material/Slide';
import React from 'react';

export interface ErrorBannerProps {
  message: string | React.ReactNode;
  severity?: 'error' | 'warning' | 'info';
  action?: React.ReactNode;
  onClose?: () => void;
  open?: boolean;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({
  message,
  severity = 'error',
  action,
  onClose,
  open = true,
}) => (
  <Slide direction="down" in={open} mountOnEnter unmountOnExit>
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.modal,
      }}
    >
      <Alert severity={severity} onClose={onClose} action={action}>
        {message}
      </Alert>
    </Box>
  </Slide>
);

export default ErrorBanner;
